import { render, staticRenderFns } from "./uploadAliResume.vue?vue&type=template&id=f7470474&scoped=true&"
import script from "./uploadAliResume.vue?vue&type=script&lang=js&"
export * from "./uploadAliResume.vue?vue&type=script&lang=js&"
import style0 from "./uploadAliResume.vue?vue&type=style&index=0&id=f7470474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7470474",
  null
  
)

export default component.exports